import { Controller } from "@hotwired/stimulus"

// Controller para mantener el estado de los checkboxes de roles entre búsquedas
export default class extends Controller {
  connect() {
    // Mantener overrides en window para persistir entre reconexiones del controller
    if (!window.rolesOverrides) window.rolesOverrides = {}
    this.overrides = window.rolesOverrides
    this.onChange = this.onChange.bind(this)
    this.onMutations = this.onMutations.bind(this)
    this.resetHandler = this.resetHandler.bind(this)

    // Listen for explicit reset event (dispatched when modal is closed)
    document.addEventListener('roles-persist:reset', this.resetHandler)

    // Escuchar cambios en los checkboxes
    this.element.addEventListener('change', this.onChange)

    // Observar cambios en la lista de roles (Turbo reemplaza el tbody)
    const target = this.element.querySelector('#roles-selected') || this.element
    this.observer = new MutationObserver(this.onMutations)
    this.observer.observe(target, { childList: true, subtree: true })

    // Aplicar overrides iniciales si existen
    this.applyOverrides()
  }

  disconnect() {
    this.element.removeEventListener('change', this.onChange)
    if (this.observer) this.observer.disconnect()
    document.removeEventListener('roles-persist:reset', this.resetHandler)
  }

  onChange(e) {
    const t = e.target
    if (!t) return
    if (t.matches && t.matches('input[name="vincular_rol_post[roles][]"]')) {
      const id = t.value
      this.overrides[id] = !!t.checked
      console.log('Override:', this.overrides)
    }
  }

  onMutations() {
    // Cuando Turbo reemplaza la lista, re-aplicar los overrides
    clearTimeout(this._mutTimeout)
    this._mutTimeout = setTimeout(() => this.applyOverrides(), 10)
  }

  applyOverrides() {
    console.log('applyOverrides', this.overrides)
    const checkboxes = this.element.querySelectorAll('input[name="vincular_rol_post[roles][]"]')
    if (!checkboxes) return
    checkboxes.forEach(cb => {
      const id = cb.value
      if (Object.prototype.hasOwnProperty.call(this.overrides, id)) {
        cb.checked = !!this.overrides[id]
      }
    })
  }

  // Handler for custom reset event; clears stored overrides and reapplies (so DOM shows backend state)
  resetHandler() {
    window.rolesOverrides = {}
    this.overrides = window.rolesOverrides
    this.applyOverrides()
    console.log('roles-persist:reset -> overrides cleared')
  }
}
